// Duck Jump — bounce up the platforms, don't fall.
export function createDoodle(host) {
  const { ctx, input } = host; const W = host.W, H = host.H;
  const PW = 62, PH = 12, JUMP = -640, G = 1500, START = H - 80;
  let x, y, vy, cam, plats, climb;
  const reset = () => { x = W / 2; y = START; vy = JUMP; cam = 0; climb = 0; plats = []; let py = START + 10; for (let i = 0; i < 10; i++) { plats.push({ x: i === 0 ? W / 2 - PW / 2 : Math.random() * (W - PW), y: py }); py -= 70; } };
  reset();
  return {
    dim: "2d", w: W, h: H, controls: ["left", "right"], score: 0, over: false,
    frame(dt) {
      if (input.held.left) x -= 300 * dt; if (input.held.right) x += 300 * dt;
      if (x < -15) x = W + 15; if (x > W + 15) x = -15;
      vy += G * dt; y += vy * dt;
      if (vy > 0) for (const p of plats) if (x > p.x - 12 && x < p.x + PW + 12 && y + 15 >= p.y && y + 15 <= p.y + PH + 18) { vy = JUMP; host.sfx.click?.(); }
      if (y < cam + H * 0.4) cam = y - H * 0.4;
      climb = Math.max(climb, START - y); this.score = Math.floor(climb / 10);
      let topY = Math.min(...plats.map((p) => p.y));
      for (const p of plats) if (p.y - cam > H + 20) { topY -= 70; p.y = topY; p.x = Math.random() * (W - PW); }
      if (y - cam > H + 30) { this.over = true; host.sfx.hit?.(); }
      ctx.fillStyle = "#1e1b4b"; ctx.fillRect(0, 0, W, H);
      ctx.fillStyle = "#34d399"; plats.forEach((p) => { const sy = p.y - cam; if (sy > -16 && sy < H + 16) ctx.fillRect(p.x, sy, PW, PH); });
      const dy = y - cam; ctx.fillStyle = "#fbbf24"; ctx.beginPath(); ctx.arc(x, dy, 15, 0, 7); ctx.fill(); ctx.fillStyle = "#f97316"; ctx.fillRect(x + 11, dy - 2, 8, 5); ctx.fillStyle = "#fff"; ctx.beginPath(); ctx.arc(x + 4, dy - 5, 4, 0, 7); ctx.fill(); ctx.fillStyle = "#000"; ctx.beginPath(); ctx.arc(x + 5, dy - 5, 2, 0, 7); ctx.fill();
    },
  };
}
